import { Edit } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { DocumentFormField } from "./DocumentFormField";

export const DocumentNames = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <Edit style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Names")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            <DocumentFormField label={t("1")} type="text" code="Name1" size="100%" data={dataState} setData={setDataState} />
            <DocumentFormField label={t("2")} type="text" code="Name2" size="100%" data={dataState} setData={setDataState} />
            <DocumentFormField label={t("3")} type="text" code="Name3" size="100%" data={dataState} setData={setDataState} />
            <DocumentFormField label={t("4")} type="text" code="Name4" size="100%" data={dataState} setData={setDataState} />
            <DocumentFormField label={t("5")} type="text" code="Name5" size="100%" data={dataState} setData={setDataState} />
            <DocumentFormField label={t("6")} type="text" code="Name6" size="100%" data={dataState} setData={setDataState} />
            <DocumentFormField label={t("7")} type="text" code="Name7" size="100%" data={dataState} setData={setDataState} />
          </div>
        }
      />
    </>
  )
}